export default {
  AvailableStartTime: 'شروع اعتبار',
  AvailableStartTimeMin: 'شروع اعتبار از',
  AvailableStartTimeMax: 'شروع اعتبار تا',
  AvailableExpireTime: 'پایان اعتبار',
  AvailableExpireTimeMin: 'پایان اعتبار از',
  AvailableExpireTimeMax: 'پایان اعتبار تا',
  CompanyDiscountAmountMin: 'تخفیف پروژه از',
  CompanyDiscountAmountMax: 'تخفیف پروژه تا',
  CompanyDiscountTypeId: 'نوع تخفیف پروژه',
  DeadlineTime: 'مهلت درج',
  DeadlineTimeMin: 'مهلت درج از',
  DeadlineTimeMax: 'مهلت درج تا',
  MarketplaceDiscountType: 'نوع تخفیف بادپا',
  MaximumCompanyDiscountAmount: 'حداکثر مقدار تخفیف پروژه',
  MaximumCompanyDiscountAmountMin: 'حداکثر مقدار تخفیف پروژه از',
  MaximumCompanyDiscountAmountMax: 'حداکثر مقدار تخفیف پروژه تا',
  MarketplaceDiscount: 'تخفیف بادپا',
  MarketplaceDiscountAmountMin: 'تخفیف بادپا از',
  MarketplaceDiscountAmountMax: 'تخفیف بادپا تا',
  MinimumMarketplaceDiscount: 'حداقل مقدار تخفیف بادپا',
  MinimumMarketplaceDiscountAmountMin: 'حداقل مقدار تخفیف بادپا از',
  MinimumMarketplaceDiscountAmountMax: 'حداقل مقدار تخفیف بادپا تا',
  MaximumMarketplaceDiscount: 'حداکثر مقدار تخفیف بادپا',
  MaximumMarketplaceDiscountAmountMin: 'حداکثر مقدار تخفیف بادپا از',
  MaximumMarketplaceDiscountAmountMax: 'حداکثر مقدار تخفیف بادپا تا',
  MinimumCompanyDiscount: 'حداقل مقدار تخفیف پروژه',
  MinimumCompanyDiscountAmountMin: 'حداقل مقدار تخفیف پروژه از',
  MinimumCompanyDiscountAmountMax: 'حداقل مقدار تخفیف پروژه تا',
  MaximumCompanyDiscount: 'حداکثر مقدار تخفیف پروژه',
  MaximumCompanyDiscountMin: 'حداکثر مقدار تخفیف پروژه از',
  MaximumCompanyDiscountMax: 'حداکثر مقدار تخفیف پروژه تا',
  Title: 'عنوان',
  StateId: 'وضعیت',
  Scope: 'حوزه مشارکت',
  Percent: 'درصد'
}
